import React from "react";

type Props = {
  width: number;
  height: number;
};

export const AdSchooliconSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 27.95 22.37`}
      fill="currentColor"
      opacity="0.6"
    >
      <path d="M15.38,8.39h-.7V7a.35.35,0,0,0-.35-.35h-.7a.34.34,0,0,0-.35.35V9.43a.34.34,0,0,0,.35.35h1.74a.34.34,0,0,0,.35-.35v-.7A.34.34,0,0,0,15.38,8.39Zm.7,5.59h-4.2a2.1,2.1,0,0,0-2.1,2.1h0V22a.35.35,0,0,0,.35.35h.7a.35.35,0,0,0,.35-.35h0V16.08a.7.7,0,0,1,.7-.7h4.19a.7.7,0,0,1,.7.7h0V22a.35.35,0,0,0,.35.35h.7a.35.35,0,0,0,.35-.35h0V16.08a2.1,2.1,0,0,0-2.1-2.1ZM26.56,8.39h-4.2V6.06a1.4,1.4,0,0,0-.62-1.17l-7-4.66a1.41,1.41,0,0,0-1.55,0l-7,4.66a1.4,1.4,0,0,0-.62,1.17V8.39H1.4A1.4,1.4,0,0,0,0,9.78V22a.35.35,0,0,0,.35.35h.7A.35.35,0,0,0,1.4,22h0V9.78H5.59V22a.35.35,0,0,0,.35.35h.7A.35.35,0,0,0,7,22H7v-16L14,1.4l7,4.66V22a.34.34,0,0,0,.34.35H22a.34.34,0,0,0,.35-.35h0V9.78h4.2V22a.34.34,0,0,0,.35.35h.7A.34.34,0,0,0,28,22h0V9.78A1.39,1.39,0,0,0,26.56,8.39ZM14,4.19a4.2,4.2,0,1,0,4.19,4.2A4.2,4.2,0,0,0,14,4.19Zm0,7a2.8,2.8,0,1,1,2.8-2.8,2.8,2.8,0,0,1-2.8,2.8Z" />
    </svg>
  );
};
